import { useLanguage } from "../contexts/LanguageContext";
import EmailIcon from "./icons/EmailIcon.svg";
import PhoneIcon from "./icons/PhoneIcon.svg";
import LinkedInIcon from "./icons/LinkedInIcon.svg";
import GithubIcon from "./icons/GithubIcon.svg";
import FacebookIcon from "./icons/icons8-facebook-48.png";
import InstagramIcon from "./icons/icons8-instagram.svg"

function Footer({ name, contact, socials }) {
  const { t } = useLanguage();
  return (
    <footer className="bg-gray-900/50 border-t border-white/10 mt-20">
      <div className="container mx-auto py-12 px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start text-center md:text-left">
          <div>
            <h3 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-cyan-400 inline-block">
              {t('contact')}
            </h3>
            <ul className="mt-4 space-y-3">
              <li className="flex items-center justify-center md:justify-start group">
                <img
                  src={EmailIcon}
                  className="w-5 h-5 text-gray-400 group-hover:text-purple-400 transition-colors"
                  alt="Email icon"
                />
                <a
                  href={`mailto:${contact.email}`}
                  className="ml-3 text-gray-300 hover:text-white transition-colors"
                >
                  {contact.email}
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start group">
                <img
                  src={PhoneIcon}
                  className="w-5 h-5 text-gray-400 group-hover:text-purple-400 transition-colors"
                  alt="Phone icon"
                />
                <span className="ml-3 text-gray-300">{contact.phone}</span>
              </li>
              <li className="flex items-center justify-center md:justify-start group"></li>
            </ul>
          </div>
          <div className="flex flex-col items-center md:items-end">
            <h3 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-cyan-400 inline-block">
              {t('findMe')}
            </h3>
            <div className="flex justify-center space-x-6 mt-4">
              <a
                href={socials.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-gray-400 hover:text-purple-400 transition-transform transform hover:-translate-y-1"
              >
                <img src={LinkedInIcon} className="w-8 h-8" alt="LinkedIn icon" />
              </a>
              <a
                href={socials.github}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="text-gray-400 hover:text-cyan-400 transition-transform transform hover:-translate-y-1"
              >
                <img src={GithubIcon} className="w-8 h-8" alt="GitHub icon" />
              </a>
              <a
                href={socials.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-gray-400 hover:text-cyan-400 transition-transform transform hover:-translate-y-1"
              >
                <img src={FacebookIcon} className="w-8 h-8" alt="Facebook icon" />
              </a>
              <a
                href={socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-gray-400 hover:text-cyan-400 transition-transform transform hover:-translate-y-1"
              >
                <img src={InstagramIcon} className="w-8 h-8" alt="Instagram icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
